<template>
  <div class="uradiogroup">
    <div class="uradiogroup__title">{{title}}</div>
    <div class="uradiogroup__content" role="radiogroup">
      <RadioInput :disabled="disabled" v-for="v in values" :key="v" v-model="val"  :name="name" :text="v" :inputvalue="v" :required="required"/>
    </div>
  </div>
</template>

<script>
import RadioInput from './RadioInput.vue'
export default {
  components: { RadioInput },
  props: {
    title: {type: String, required: true},
    modelValue: {type: String},
    values: {type: Array, required: true},
    name: {type: String, required: true},
    required: {type: Boolean},
    disabled: { type: Boolean, default: false },
  },
  computed: {
    val:{
      get(){
        return this.modelValue
      },
      set(v){
        this.$emit('update:modelValue', v)
      },
    }
  }
}
</script>

<style lang="sass" scoped>
.uradiogroup
  padding-top: 12px
  &__title
    font-size: 16px
    line-height: 1.12
    color: colors.$newgray
    margin-bottom: 18px
  &__content
    display: grid
    grid-gap: 32px
    margin-left: 17px
    gap: 32px
    grid-template-columns: 127px 127px
    justify-content: start
    align-content: start
  @include for-mob
    padding-top: 20px
    &__title
      font-size: 16px
      margin-bottom: 15px
  @include from(350px)
    &__content
      grid-template-columns: auto auto
</style>